module.exports = __webpack_public_path__ + "static/media/icn-menu.02a5ae76.svg";